<template>
  <!-- เมนูกระบวนงาน — แก้รายการเมนูที่ adminProcessMenus.js (personnel) -->
  <AdminProcessNav v-bind="menu" />
</template>

<script>
import AdminProcessNav from "./AdminProcessNav.vue";
import { ADMIN_MENUS } from "./adminProcessMenus";

export default {
  name: "HRvecPersonnelmenu",
  components: { AdminProcessNav },
  data() {
    return { menu: ADMIN_MENUS.personnel };
  }
};
</script>
